<template>
    <LoaderCar v-if="loading" width="600px" marginTop="0"/>
    <div class="code-bg" v-else>
        <HeaderHome :user="this.$store.state.user.prenom"/>
        <CodePaiement v-if="!checkCodePaiement"/>
        <CodePrepa v-if="checkCodePaiement"/>
    </div>
</template>
<script>
import CodePaiement from '../../../components/eleve/code/CodePaiement.vue';
import CodePrepa from '../../../components/eleve/code/CodePrepa.vue';
import HeaderHome from '../../../components/home/HeaderHome.vue';
import LoaderCar from '../../../components/LoaderCar.vue';

export default {
    components:{
        HeaderHome,
        CodePaiement,
        CodePrepa,
        LoaderCar
    },

    data() {
        return {
            checkCodePaiement: false,
            loading: true,
        }
    },

    mounted() {
        this.checkOnePaiement("code");
    },

    methods: {
        checkOnePaiement(label) {
            window.api
                .get("/student/"+this.$store.state.user.id+"/paiement/"+label, {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                    },
                    })
                    .then((response) => {
                        this.checkCodePaiement = response.data.paid;
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.log(error.response.data.message);
                    });
            },
    },
}
</script>
<style scoped>
    div.code-bg{

        
    }
</style>